
import React, { useState, useEffect } from 'react';
import { UrbanZaikhaLogo } from './Logo';

const Header: React.FC = () => {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id: string) => {
    document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <header className={`fixed top-0 left-0 w-full z-40 transition-all duration-300 ${isScrolled ? 'bg-[#0a3d34] shadow-lg' : 'bg-transparent'}`}>
      <div className="container mx-auto px-6 py-2 flex justify-between items-center">
        <button onClick={() => scrollToSection('hero')} aria-label="Scroll to top">
          <UrbanZaikhaLogo size="small" />
        </button>
        <nav className="hidden md:flex space-x-8">
          <button onClick={() => scrollToSection('about')} className="text-[#f0e1b2] hover:text-white transition-colors duration-300">Our Story</button>
          <button onClick={() => scrollToSection('menu')} className="text-[#f0e1b2] hover:text-white transition-colors duration-300">Menu</button>
          <button onClick={() => scrollToSection('contact')} className="text-[#f0e1b2] hover:text-white transition-colors duration-300">Order Now</button>
        </nav>
      </div>
    </header>
  );
};

export default Header;